export default "__VITE_ASSET__CleUyuCu__"